import { Flex } from "@chakra-ui/react";
import { BookDemoButton } from "components/event-tracking";
import { HeroVideo } from "components/hero";
import { Section } from "components/section";
import React from "react";
import { FadeIn } from "ui/animations";
import { TextTitle } from "ui/text";

type EventCollectionHeroProps = {
  eyebrow: string;
  title: string;
  description: string;
};

export function EventCollectionHero({ eyebrow, title, description }: EventCollectionHeroProps) {
  return (
    <Section
      theme="dark"
      bg="new.gray.950"
      themeBgColor="new.gray.950"
      py="0"
      pt={{ base: "biggest", lg: "huge" }}
      pb={{ base: "huge", lg: "huger" }}
    >
      <FadeIn duration={0.3}>
        <Flex gap="bigger" flexDir={{ base: "column", lg: "row" }} alignItems="center">
          <TextTitle
            theme="dark"
            size="xl"
            chip={{ text: eyebrow }}
            titleAs="h1"
            title={title}
            descriptionAs="h2"
            description={description}
            actions={<BookDemoButton />}
            maxW={{ base: "100%", lg: "50%" }}
          />

          <HeroVideo
            isTransparent
            title="Hightouch Events"
            description={description}
            alt='An animation that starts by showing a generic ecommerce website page. A cursor on the screen selects a pair of shoes from the catalog, then a popup appears showing Hightouch Events tracking a "Product Viewed" event with your Data Warehouse, including additional metadata like the category, color, and SKU of the product. The cursor then clicks the "Buy" button, and Hightouch Events tracks an "Order Complete" event with the SKU and order total metadata included.'
            uploadDate="2023-10-03T08:00:00+08:00"
            sourceMp4="https://cdn.sanity.io/files/pwmfmi47/production/c646efd817115d0c28dcd41b3559bbd56cedbde2.mp4"
            sourceWebm="https://cdn.sanity.io/files/pwmfmi47/production/4933f1c853c5e09783eed874025c81f9057e0dd1.webm"
            poster="https://cdn.sanity.io/images/pwmfmi47/production/cf3e67fd07c68f102dccd0ad680ef4b9a65f0df2-1400x1096.png"
            maxW={{ base: "mediaMaxW.mobile", md: "70%", lg: "100%" }}
          />
        </Flex>
      </FadeIn>
    </Section>
  );
}
